import api, { baseApiService } from "shared/api";
import useSWRImmutable from "swr/immutable";

export const reasonsOfRejectionFetcher = (url) =>
  // TODO use toReasonsOfRejectionOptionsTransformer after backend translations merge
  api
    .get(url)
    .then((res) =>
      res.data.data.map((reason) => ({ value: reason.id, label: reason.name }))
    );

export function useReasonsOfRejection({ triggerRequest = false } = {}) {
  return useSWRImmutable(
    triggerRequest
      ? baseApiService.ENDPOINTS.accounts_payable.reasons_of_rejection
      : null,
    reasonsOfRejectionFetcher
  );
}
